module.exports = __webpack_public_path__ + "static/media/styled-components.2c199c96.png";